import { FC } from "react";
import { CustomButton } from "../../CustomButton/CustomButton";
import { ModalComponent } from "../UiModals";
import { CancelIcon } from "../../icons/CacnelIcon";

interface IProps {
    onSuccess: () => void;
    isMobile: boolean;
}

interface IPropsActions extends IProps {
    close: () => void;
}

const Modal: FC<IPropsActions> = ({
                                      close,
                                      isMobile = false,
                                      onSuccess
                                  }) => {
    const deleteChat = () => {
        onSuccess();
    }

    return (
        <div className={`communication-modal-container ${isMobile ? 'communication-modal-container_mobile' : ''}`}>
            <div className="communication-modal-content" style={{width: 400}}>
                <div className="communication-modal-title communication-modal-title_contacts">
                    <div className="communication-modal-title__text">Удалить сообщение</div>
                </div>
            <div className="communication-modal-body communication-modal-body_contacts">
                <div className="communication-modal-content" style={{fontSize: 16, color: 'var(--messenger-black)', marginBottom: 24}}>
                    Вы действительно хотите удалить сообщение?
                </div>
                <div className="communication-modal-footer communication-modal-footer_start">
                    <CustomButton
                        style={{maxHeight: 40, height: 24, padding: '8px 12px'}}
                        onClick={deleteChat}
                        isCancel={true}
                    >
                        Удалить
                    </CustomButton>
                    <CustomButton
                        style={{maxHeight: 40, height: 24, padding: '8px 12px'}}
                        outline
                        onClick={close}
                    >
                        Отменить
                    </CustomButton>
                </div>
            </div>
        </div>
            <CustomButton
                onClick={close}
                isRound={true}
                outline={true}
            ><CancelIcon /></CustomButton>
        </div>
    );
};

export const DeleteMessage = (props: IProps): ModalComponent => {
    return ({ close }) => {
        return <Modal close={close} {...props} />;
    };
};